<template>
  <div class="grid grid-cols-12 text-xs text-gray-600 gap-x-4 p-4 items-end">
    <div class="col-span-3">Description</div>
    <div>Quantity</div>
    <div class="col-span-2">Price per Unit</div>
    <div class="text-right">Net Amount</div>
    <div class="col-span-2">Vat Rate</div>
    <div class="text-right">Vat Amount</div>
    <div class="text-right">Line Item Total</div>
  </div>
</template>

<script>
export default {
  //
};
</script>
